// SAB-522: /terms — previously 404'd. Renders the Terms of Service page with the
// canonical Termly-hosted policy embedded/linked.
//
// SAB-767: the Aeropay end-user ToS section was REMOVED. It existed to satisfy Aeropay
// Integration Agreement Section 6, and Aeropay declined to onboard us — Soap is the
// processor. A required disclosure for a contract we do not have is a misstatement, not a
// formality, and this page goes to Soap's underwriting.
//
// The page is complete without it: the authoritative published policy is the Termly
// document rendered by the shell. The removed section was never legal TEXT — it was a
// "being finalized" notice plus a link to Aeropay's public document.
//
// NOT COVERED HERE: whether the Termly-hosted Terms itself names Aeropay. That content
// lives in Termly, not this repo, and must be checked separately.
import LegalPageShell, { TERMLY_POLICIES } from './LegalPageShell';

export default function TermsPage() {
  return <LegalPageShell title="Terms of Service" termlyUrl={TERMLY_POLICIES.terms} />;
}
